export default __webpack_public_path__ + "static/media/IconF2.57a775f0.svg";